import React, {Component} from 'react'
import AsyncSelect from 'react-select3/async'
import PropTypes from 'prop-types'
import request from 'superagent'

export default class ClioMatterSearch extends Component {
  static propTypes = {
    connectionId: PropTypes.number.isRequired,
    onSelectMatter: PropTypes.func.isRequired,
  };

  loadClioMatters = (inputValue) => {
    const {connectionId} = this.props;

    return request.get(`/rpc/integrations/connections/${connectionId}/clio/matters`)
      .query({ query: inputValue })
      .then(response => response.body.data);
  }

  render() {
    return (
      <AsyncSelect
        cacheOptions
        defaultOptions
        loadOptions={this.loadClioMatters}
        isClearable
        placeholder="Search Clio Matters..."
        getOptionValue={option => option.id}
        getOptionLabel={option => <span><b>{option.display_number}</b> - {option.description}</span>}
        onChange={option => this.props.onSelectMatter(option)}
      />
    );
  }
}


// WEBPACK FOOTER //
// ./src/CaseFolder/Integrations/Clio/ClioMatterSearch.jsx